import { fail, success } from '@helpers/result-helper'
import toast from '@services/toasts/index'
import { isSuccess } from '@/helpers/http-status-helpers'
import TimesheetsViewModel from '@/models/timesheets/timesheetsViewModel'

const getDefaultState = () => {
  return {
    // Place any new state properties here
    loadingCount: 0,
    crudLoadingCount: 0,
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    moduleName: () => 'timesheets',
    isLoading: (state) => state.loadingCount > 0,
    isLoadingCRUD: (state) => state.crudLoadingCount > 0,
  },
  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    START_LOADING_CRUD(state) {
      state.crudLoadingCount++
    },
    FINISH_LOADING_CRUD(state) {
      state.crudLoadingCount--
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async loadTimesheets({ commit, rootGetters }) {
      commit('START_LOADING')

      try {
        const cId = rootGetters['client/selectedClientId']
        const response = await this.$api.timesheets.get(cId)

        if (isSuccess(response.status)) {
          return success(new TimesheetsViewModel(response.data))
        }
      } catch {
        toast.error(this.$i18n.t('timesheets.loadFailureToastText'))
        return fail()
      } finally {
        commit('FINISH_LOADING')
      }
    },
    async submitTimesheetsForApproval({ commit }, timesheets) {
      commit('START_LOADING_CRUD')

      try {
        const response = await this.$api.timesheets.post('', timesheets)

        if (isSuccess(response.status)) {
          toast.success(this.$i18n.t('timesheets.submissionSuccessToastText'))
          return success(response.data)
        }
      } catch {
        toast.error(this.$i18n.t('timesheets.submissionFailureToastText'))
        return fail()
      } finally {
        commit('FINISH_LOADING_CRUD')
      }
    },
    async downloadTimesheet({ commit }, timesheetRecordId) {
      commit('START_LOADING')
      try {
        const response = await this.$api.timesheets.downloadTimesheetFile(
          timesheetRecordId
        )

        if (isSuccess(response.status)) {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: 'application/pdf' })
          )
          return success(url)
        }
      } catch (ex) {
        let toastErrorMessage = this.$i18n.t('error.errorGenericApiErrorText')
        // Try to resolve error response. Response type is Blob, need to convert
        // from blob to json
        try {
          const responseObject = JSON.parse(await ex.response.data.text())
          if (responseObject) toastErrorMessage = responseObject.message
        } catch {}

        toast.error(toastErrorMessage)

        return fail()
      } finally {
        commit('FINISH_LOADING')
      }
    },
    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
  },
}
